import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesAnalystCoverageHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Analyst Coverage Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageHeroContentSectionHeaderCls || '', 'investors_resources_analyst_coverage_hero', { animCls: 'animate__fadeInDown', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;